var map = {
	"./Avatar.svg": 7182,
	"./Facebook_Footer.svg": 2590,
	"./Features_1.svg": 1793,
	"./Features_2.svg": 717,
	"./Features_3.svg": 8558,
	"./Instagram_Footer.svg": 1822,
	"./Mail_Footer.svg": 236,
	"./SearchIcon.svg": 1870,
	"./Twitter_Footer.svg": 7841,
	"./Youtube_Footer.svg": 6993,
	"./calendar.svg": 874,
	"./eye.svg": 5564,
	"./facebook.svg": 3902,
	"./injection_needle.svg": 3454,
	"./instagram.svg": 673,
	"./left_arrow.svg": 394,
	"./placeholder-user.svg": 3994,
	"./right_arrow.svg": 1396,
	"./share.svg": 3906,
	"./top.svg": 5395,
	"./translateIcon.svg": 8438,
	"./twitter.svg": 3961,
	"./youtube.svg": 2388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;